<template>
  <div class="row">
    <section id="faq-mobile" class="d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none">
      <div class="col-10 offset-1 mb-4">
        <span class="text-center get-your-loan section-title section-title-green">Preguntas frecuentes</span>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq1 v-if="country === 'co'">
        <span class="faq-title">¿Prestan a reportados?</span>
        <b-collapse id="faq1" class="faq-answer">
        ¡SI! En ábaco te ayudamos a generar una nueva vida crediticia que te permitirá acceder de nuevo a un crédito.
        </b-collapse>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq2 v-if="country === 'co' || uber">
        <span class="faq-title">¿Prestan a venezolanos con PEP?</span>
        <b-collapse id="faq2" class="faq-answer">
        Claro que sí, Ábaco aprueba a todos los que trabajen en plataformas sin tener en cuenta que estén reportados o no tengan vida crediticia o tenga PEP. Por eso es que insistimos en ser muy  puntuales  y  rigurosos  con  sus  créditos  adquiridos  para  que  puedan  acceder  a  mas créditos de mayores montos y ¡Hacer vida crediticia!
        </b-collapse>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq3 v-if="country === 'co'">
        <span class="faq-title">¿Cómo me inscribo?</span>
      </div>
        <b-collapse id="faq3" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>
        <div class="col-10 offset-1 faq-question" v-b-toggle.faq12 v-if="country === 'mx'">
          <span class="faq-title">¿Cómo me registro?</span>
        </div>
        <b-collapse id="faq12" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register_mx + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>
        <div class="col-10 offset-1 faq-question" v-b-toggle.faq13 v-if="country === 'pe'">
          <span class="faq-title">¿Estás en Perú y no sabes como registrarte? Sigue estos pasos</span>
        </div>
        <b-collapse id="faq13" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register_pe + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

      <div class="col-10 offset-1 faq-question" v-b-toggle.faq7 v-if="country === 'mx'">
        <span class="faq-title">¿Qué requisitos necesito para aplicar a un crédito?</span>
        <b-collapse id="faq7" class="faq-answer">
        Solo necesitas estar activo en alguna plataforma (Rappi, Uber, UberEats, Didi, Mensajeros Urbanos, Lalamove, entre otras) y registrarte.
        </b-collapse>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq8 v-if="country === 'mx'">
        <span class="faq-title">¿En cuánto tiempo me resuelven mi solicitud?</span>
        <b-collapse id="faq8" class="faq-answer">
        ¡Muy rápido! Tan solo 2 días hábiles después de que completaste correctamente tu registro.
        </b-collapse>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq9 v-if="country === 'mx'">
        <span class="faq-title">¿Qué hago si mi crédito fue negado?</span>
        <b-collapse id="faq9" class="faq-answer">
        ¡No te preocupes! Puedes hacer una nueva solicitud cada mes, si tienes dudas, puedes contactar a un asesor.
        </b-collapse>
      </div>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq10 v-if="country === 'mx'">
        <span class="faq-title">¿Cómo puedo aplicar para otro crédito?</span>
      </div>
      <b-collapse id="faq10" class="faq-answer">
        <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.new_application + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
      </b-collapse>

      <div class="col-10 offset-1 faq-question" v-b-toggle.faq11 v-if="country === 'mx'">
        <span class="faq-title">¿Qué puedo hacer si mis datos aparecen como ya registrados?</span>
      </div>
      <b-collapse id="faq11" class="faq-answer">
      Esto puede suceder debido a que intentaste una solicitud en el pasado, y tus datos se
        quedaron guardados. Solo debes ingresar en el botón "Entra aquí" para que puedas acceder
        directamente a tu perfil y puedas modificar todo lo que necesites.
      </b-collapse>

      <div class="faq-question offset-1 faq-question" v-b-toggle.faq4>
        <span class="faq-title">¿Cómo restauro mi contraseña?</span>
      </div>
      <b-collapse id="faq4" class="faq-answer">
        <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.restore_password + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
      </b-collapse>

      <div class="col-10 offset-1 faq-question" v-b-toggle.faq5 v-if="country === 'co'">
        <span class="faq-title">¿Cómo solicito un nuevo crédito?</span>
      </div>
      <b-collapse id="faq5" class="faq-answer">
        <div style="display: table">
          <div style="display: flex">
            A través de tu area de usuario puedes hacerlo. Recuerda volver a validar la información de tus Apps.
          </div>
          <br>
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.new_application + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </div>
      </b-collapse>

      <div class="col-10 offset-1 faq-question" v-b-toggle.faq6>
        <span class="faq-title">¿Cómo cargo los pagos del crédito?</span>
      </div>
      <b-collapse id="faq6" class="faq-answer">
        <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.payments + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
      </b-collapse>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq15>
        <span class="faq-title">¿Como validar las Apps en tu perfil Ábaco?</span>
      </div>
      <b-collapse id="faq15" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.validate_apps + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
      </b-collapse>
      <div class="col-10 offset-1 faq-question" v-b-toggle.faq14>
        <span class="faq-title">¿Por que pagar al día las cuotas de mi crédito Ábaco?</span>
      </div>
      <b-collapse id="faq14" class="faq-answer">
        <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.why_pay_installments + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
      </b-collapse>
    </section>

    <section id="faq-desktop" class="d-none d-sm-block">
      <div class="col-12 mb-3 text-left mt-sm-5 mt-md-5 mt-lg-5 mt-xl-5 mt-xxl-5">
        <span class="text-center get-your-loan section-title section-title-green">Preguntas frecuentes</span>
      </div>
      <div class="col-8">
        <div class="faq-question" v-b-toggle.faq1 v-if="country === 'co'">
          <span class="faq-title">¿Prestan a reportados?</span>
        </div>
        <b-collapse id="faq1" class="faq-answer">
          ¡SI! En ábaco te ayudamos a generar una nueva vida crediticia que te permitirá acceder de nuevo a un crédito.
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq2 v-if="country === 'co' || uber">
          <span class="faq-title">¿Prestan a venezolanos con PEP?</span>
        </div>
        <b-collapse id="faq2" class="faq-answer">
          Claro que sí, Ábaco aprueba a todos los que trabajen en plataformas sin tener en cuenta que estén reportados o no tengan vida crediticia o tenga PEP. Por eso es que insistimos en ser muy  puntuales  y  rigurosos  con  sus  créditos  adquiridos  para  que  puedan  acceder  a  mas créditos de mayores montos y ¡Hacer vida crediticia!
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq3 v-if="country === 'co'">
          <span class="faq-title">¿Cómo me inscribo?</span>
        </div>
        <b-collapse id="faq3" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq12 v-if="country === 'mx'">
          <span class="faq-title">¿Cómo me registro?</span>
        </div>
        <b-collapse id="faq12" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register_mx + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq13 v-if="country === 'pe'">
          <span class="faq-title">¿Estás en Perú y no sabes como registrarte? Sigue estos pasos</span>
        </div>
        <b-collapse id="faq13" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.register_pe + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq7 v-if="country === 'mx'">
          <span class="faq-title">¿Qué requisitos necesito para aplicar a un crédito?</span>
        </div>
        <b-collapse id="faq7" class="faq-answer">
          Solo necesitas estar activo en alguna plataforma (Rappi, Uber, UberEats, Didi, Mensajeros Urbanos, Lalamove, entre otras) y registrarte.
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq8 v-if="country === 'mx'">
          <span class="faq-title">¿En cuánto tiempo me resuelven mi solicitud?</span>
        </div>
        <b-collapse id="faq8" class="faq-answer">
          ¡Muy rápido! Tan solo 2 días hábiles después de que completaste correctamente tu registro.
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq9 v-if="country === 'mx'">
          <span class="faq-title">¿Qué hago si mi crédito fue negado?</span>
        </div>
        <b-collapse id="faq9" class="faq-answer">
          ¡No te preocupes! Puedes hacer una nueva solicitud cada mes, si tienes dudas, puedes contactar a un asesor.
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq10 v-if="country === 'mx'">
          <span class="faq-title">¿Cómo puedo aplicar para otro crédito?</span>
        </div>
        <b-collapse id="faq10" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.new_application + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq11 v-if="country === 'mx'">
          <span class="faq-title">¿Qué puedo hacer si mis datos aparecen como ya registrados?</span>
        </div>
        <b-collapse id="faq11" class="faq-answer">
          Esto puede suceder debido a que intentaste una solicitud en el pasado, y tus datos se
          quedaron guardados. Solo debes ingresar en el botón "Entra aquí" para que puedas acceder
          directamente a tu perfil y puedas modificar todo lo que necesites.
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq4>
          <span class="faq-title">¿Cómo restauro mi contraseña?</span>
        </div>
        <b-collapse id="faq4" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.restore_password + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq5 v-if="country === 'co' || uber">
          <span class="faq-title">¿Cómo solicito un nuevo crédito?</span>
        </div>
        <b-collapse id="faq5" class="faq-answer">
          A través de tu area de usuario puedes hacerlo. Recuerda volver a validar la información de tus Apps.
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.new_application + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq6>
          <span class="faq-title">¿Cómo cargo los pagos del crédito?</span>
        </div>
        <b-collapse id="faq6" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.payments + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq15>
          <span class="faq-title">¿Como validar las Apps en tu perfil Ábaco?</span>
        </div>
        <b-collapse id="faq15" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.validate_apps + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

        <div class="faq-question" v-b-toggle.faq14>
          <span class="faq-title">¿Por que pagar al día las cuotas de mi crédito Ábaco?</span>
        </div>
        <b-collapse id="faq14" class="faq-answer">
          <LazyYoutubeVideo v-bind:src="'https://www.youtube.com/embed/' + videos.why_pay_installments + '?controls=0'" alt="YouTube video player" :iframeAttributes="{frameborder: 0, allowfullscreen: true, allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}"/>
        </b-collapse>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  props: {
    country: {
      type: String,
      default: 'co'
    },
    uber: {
      type: Boolean,
      default: false
    },
    videos: {
      type: Object,
      default () {
        return {
          register: 'SqpL9iQp4Bk',
          register_mx: '7NjKKVIaPz8',
          register_pe: 'yThGCUcDB10',
          new_application: 'Q5rbAa4s8ok',
          restore_password: 'CmeFzGb73Dc',
          payments: 'wZZx5XgoNmE',
          validate_apps: 'CRXNSBf3k-Y',
          why_pay_installments: 'igyd5CzInfk'
        }
      }
    }
  }
}
</script>

<style>
.faq-title {
  height: 24px;
  color: #333333;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}
.faq-question {
  padding-bottom: 15px;
  margin-top: 15px;
  border-bottom: 1px solid #D8D8D8;
}
.faq-answer {
  font-size: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}
.faq-oval {
  opacity: 0.29;
  background-color: #F3D7BD;
  position: relative;
  border-radius: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue